import React, { useState } from "react";
import BaseButton from "../../../../components/BaseButton";
import { useTranslation } from "react-i18next";
import Game from "../../../../store/Game";
import { v4 as uuidv4 } from "uuid";
import useBrowserStorage from "../../../../hooks/useBrowserStorage";
import useAuth from "../../../../hooks/useAuth";
import INTOUCH_API from "../../../../services/Api";
import useCurrentUserData from "../../../../hooks/useCurrentUserData";
import PersonalAccount from "../../../../store/PersonalAccount";
import {
  ADULT_ALERT_WAS_SHOWN,
  CURRENT_GAME_KEY,
  TEMPORARY_ID_KEY,
} from "../../../../utils/constants";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../../utils/routes";
import { MODAL_TYPES } from "../../../../utils/emitter";
import useModalActions from "../../../../hooks/useModalActions";

export default function MobileAppSectionMainTitle() {
  const { getUserData } = useCurrentUserData();
  const { setItem, getItem } = useBrowserStorage();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [isDemoGameLoading, setIsDemoGameLoading] = useState(false);
  const { openModal } = useModalActions();

  const startDemoGame = async () => {
    setIsDemoGameLoading(true);
    const demoForm = {
      type: "DEMO",
    };

    const wasShown = getItem(ADULT_ALERT_WAS_SHOWN);
    if (!wasShown) {
      openModal(MODAL_TYPES.ADULT_ALERT);
    }
    if (token) {
      const userData = getUserData();
      demoForm.userId = userData.id;
      await PersonalAccount.getPersonalAccountData();
      const isManyDemoGames = PersonalAccount.games.length > 1;
      if (isManyDemoGames) {
        navigate(ROUTES.PERSONAL_ACCOUNT_PAGE);
      } else if (PersonalAccount.games.length === 1) {
        const game = PersonalAccount.games[0];
        if (game.type === "DEMO") {
          Game.setGame(game);
          if (
            !PersonalAccount.user.gameIdsByMeets.some((id) => id === game.id)
          ) {
            navigate(ROUTES.MEET_PAGE);
          }
        } else {
          navigate(ROUTES.PERSONAL_ACCOUNT_PAGE);
        }
      }
    } else {
      let temporaryUserId = "";
      const savedTemporaryUserId = getItem(TEMPORARY_ID_KEY);
      if (savedTemporaryUserId) {
        temporaryUserId = savedTemporaryUserId;

        await INTOUCH_API.requestManager(
          "temporary_current_user",
          { temporaryUserId },
          (response) => {
            Game.getCards("questions_cards_demo", true, null);
            setItem(CURRENT_GAME_KEY, response.data);
            Game.setGame(response.data);
            navigate(ROUTES.MEET_PAGE, { state: { from: "landing" } });
          },
          () => {},
          () => setIsDemoGameLoading(false)
        );
      } else {
        temporaryUserId = uuidv4();
        setItem("temporaryUserId", temporaryUserId);
        demoForm.temporaryUserId = temporaryUserId;

        await INTOUCH_API.requestManager(
          "createDemoGame",
          demoForm,
          (response) => {
            Game.getCards("questions_cards_demo", true, null);
            setItem(CURRENT_GAME_KEY, response.data);
            Game.setGame(response.data);
            navigate(ROUTES.MEET_PAGE, { state: { from: "landing" } });
          },
          () => {},
          () => {
            setIsDemoGameLoading(false);
          }
        );
      }
    }
  };

  const { t } = useTranslation();

  return (
    <section className="mobile-mobile-section-main-title">
      <div className="mobile-section-main-title__container">
        <div
          data-text={t("main_entry_page.test")}
          className="mobile-section-main-title__test-title neon-text"
        >
          {t("main_entry_page.test")}
        </div>
        <div
          data-text={t("main_entry_page.title")}
          className="mobile-section-main-title__title neon-text"
        >
          {t("main_entry_page.title")}
        </div>
      </div>
      <div className="mobile-section-main-title__desc">
        {t("main_entry_page.desc")}
      </div>
      <div className="mobile-section-main-title__navigate-buy">
        <BaseButton
          loading={isDemoGameLoading}
          onClick={() => startDemoGame()}
          className="mobile-section-main-title__button__menu"
        >
          {t("demo")}
        </BaseButton>
      </div>
    </section>
  );
}
